import React from "react";
import { Link } from "react-router-dom";
import { NavbarBrand, Navbar, Container } from "reactstrap";

const AuthNavbar = props => {
  // const { settings } = props;

  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark" expand="md">
        <Container className="px-4">
          <NavbarBrand to="/" tag={Link}>
            <img className="logo" src="/logo/rcbc-transparent-v2.png" alt="Rizal Commercial Banking Corporation" />
          </NavbarBrand>
        </Container>
      </Navbar>
    </>
  );
}

export default AuthNavbar;
